import axios from 'axios';
import { handleApiError } from '../../utils/errorHandler';

const API_BASE_URL = 'https://app.insight360apps.com/easycheck/api';

// Separate Axios instance for super admin — uses superAdminToken
const superAdminApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

superAdminApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('superAdminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.metadata = { startTime: new Date() };
    return config;
  },
  (error) => Promise.reject(error)
);

superAdminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('superAdminToken');
      localStorage.removeItem('superAdminUser');
      if (window.location.pathname.startsWith('/super-admin') && !window.location.pathname.includes('/login')) {
        window.location.href = '/super-admin/login';
      }
    }
    return Promise.reject(error);
  }
);

// Response wrapper matching easyCheckRequest pattern
const superAdminRequest = async (requestFn) => {
  try {
    const response = await requestFn();
    const responseData = response.data;
    const success = responseData.success ?? responseData.Success ?? true;
    const data = responseData.data ?? responseData.Data ?? responseData;
    const message = responseData.message ?? responseData.Message ?? 'Success';

    return {
      success,
      data,
      message,
      TotalCount: responseData.TotalCount,
      PageNumber: responseData.PageNumber,
      PageSize: responseData.PageSize,
      TotalPages: responseData.TotalPages,
      totalCount: responseData.TotalCount || responseData.totalCount,
      pageNumber: responseData.PageNumber || responseData.pageNumber,
      pageSize: responseData.PageSize || responseData.pageSize,
      totalPages: responseData.TotalPages || responseData.totalPages
    };
  } catch (error) {
    return handleApiError(error);
  }
};

export { superAdminApi, superAdminRequest };
export default superAdminApi;
